import { useEffect, useState } from "react";
import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  VStack,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo.png";
import useLogin from "api/mutations/useLogin";
import FormikInput from "components/formikInput";
import kidsImage from "../../assets/register-image-kids.png";
import { useUserContext } from "context/UserContext";
import useForgotPassword from "api/mutations/useForgotPassword";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required("Email cannot be empty"),
      // password: Yup.string().required("Password cannot be empty"),
      // rememberMe: Yup.boolean().required("Select an option for remember me"),
    }),
    onSubmit: (values) => handleForgotPassword(values),
  });

  const forgotPasswordMutation = useForgotPassword({
    onSuccess: (res) => {
      if (res.status === 200) {
        toast({
          title: "OTP sent successfully!",
          description:
            "Please check your email for the OTP to reset your password.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        localStorage.setItem("email", formik.values.email);
        navigate("/verification");
      }
    },
    onError: (err) => {
      const response = err.response;
      toast({
        title: "Something went wrong. Please try again later.",
        description: response?.data?.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleForgotPassword = async (values) => {
    try {
      const data = {
        email: values.email,
        role: "seller",
      };
      forgotPasswordMutation.mutate(data);
    } catch (e) {
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={8} width={400}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Forgot your Password
          </Text>

          <VStack align="flex-center" spacing={8}>
            <FormikInput
              name="email"
              type="text"
              label="Enter Your Email Address"
              placeholder={"Enter Your Email Address"}
              formik={formik}
            />
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"48px"}
              _hover={{
                bg: "#456EFF",
                color: "#FFFFFF",
              }}
              onClick={formik.handleSubmit}
              isDisabled={!formik.values.email}
            >
              {forgotPasswordMutation.isLoading ? <Spinner /> : "Continue"}
            </Button>
          </VStack>
        </VStack>
      </Box>
      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default ForgotPassword;
